import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumb, Breadcrumbs } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import { useAboutSiteNav, useAboutSiteToggleNav } from '../Navigation/AboutSiteNavButton.context'
import Jumbotron from '../Basics/Jumbotron'
import {
  Content,
  Description,
  GridContainer,
  GridItem,
  HideContainer,
  Item,
  Link,
  NavContainer,
  NavOverlay,
  Root,
  Title
} from './AboutLayout.styles'

/**
 * The AboutLayout's component.
 */
const AboutLayout = props => {
  const { children, menuActive } = props
  const navToggle = useAboutSiteNav()
  const toggleNav = useAboutSiteToggleNav()
  return (
    <Root>
      <GridContainer>
        <GridItem xs={12}>
          <Jumbotron>
            <Breadcrumbs>
              <Breadcrumb to={routes.root} variant="link">
                Datos Abiertos
              </Breadcrumb>
              <Breadcrumb>Sobre Datos Abiertos</Breadcrumb>
            </Breadcrumbs>
            <Title>Sobre Datos Abiertos</Title>
            <Description>
              Conoce más sobre nuestro sitio de Datos Abiertos, cómo se obtienen los datos <br /> desde Mercado Público
              y el uso de la presente plataforma.
            </Description>
          </Jumbotron>
        </GridItem>
      </GridContainer>
      <Content>
        <GridContainer spacing={2}>
          {navToggle ? (
            <>
              <NavContainer>
                <Item>
                  <Link
                    active={menuActive === routes.about || menuActive === routes.aboutSiteGoal}
                    to={routes.aboutSiteGoal}
                  >
                    Objetivo del sitio
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.aboutDataGoal} to={routes.aboutDataGoal}>
                    Origen de los datos
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.aboutSuggestData} to={routes.aboutSuggestData}>
                    Sugerir datos
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.aboutDefinitions} to={routes.aboutDefinitions}>
                    Definiciones
                  </Link>
                </Item>
                <Item>
                  <Link active={menuActive === routes.aboutVideoTutorials} to={routes.aboutVideoTutorials}>
                    Videotutoriales
                  </Link>
                </Item>
              </NavContainer>
              <NavOverlay onClick={toggleNav} />
            </>
          ) : (
            <>
              <HideContainer only={['xs', 'sm']}>
                <GridItem xs={12} md={3}>
                  <Item>
                    <Link
                      active={menuActive === routes.about || menuActive === routes.aboutSiteGoal}
                      to={routes.aboutSiteGoal}
                    >
                      Objetivo del sitio
                    </Link>
                  </Item>
                  <Item>
                    <Link active={menuActive === routes.aboutDataGoal} to={routes.aboutDataGoal}>
                      Origen de los datos
                    </Link>
                  </Item>
                  <Item>
                    <Link active={menuActive === routes.aboutSuggestData} to={routes.aboutSuggestData}>
                      Sugerir datos
                    </Link>
                  </Item>
                  <Item>
                    <Link active={menuActive === routes.aboutDefinitions} to={routes.aboutDefinitions}>
                      Definiciones
                    </Link>
                  </Item>
                  <Item>
                    <Link active={menuActive === routes.aboutVideoTutorials} to={routes.aboutVideoTutorials}>
                      Videotutoriales
                    </Link>
                  </Item>
                </GridItem>
              </HideContainer>
            </>
          )}
          <GridItem xs={12} md={9}>
            {children}
          </GridItem>
        </GridContainer>
      </Content>
    </Root>
  )
}

AboutLayout.defaultProps = {
  menuActive: routes.root
}

AboutLayout.propTypes = {
  children: PropTypes.node.isRequired,
  menuActive: PropTypes.string
}

export default AboutLayout
